import React from "react"
import { ReportSection } from "~/api/communications"
import QuarterlyReportLayout from "./QuarterlyReportLayout"
import PdfPageWrapper from "./PdfPageWrapper"
import { useCommunicationContext } from "./CommunicationContext"
import { useQuarterlyReportContext } from "./useQuarterlyReportContext"
import { usePdfView } from "./usePdfView"
import USMap from "./USMap"
import { GeographicExposureTable } from "@/editor/GeographicExposureTableTool"

const ExposureByGeography: React.FC = () => {
  const { communicationId } = useCommunicationContext()
  const { reportId, report, isLoading, error, mock } =
    useQuarterlyReportContext()
  const { showPdfView, pdfLoading, pdfUrl, togglePdfView, loadPdfView } =
    usePdfView({
      reportId,
      sectionName: ReportSection.EXPOSURE_BY_GEOGRAPHY,
      editorContent: { section: "exposure_by_geography", reportId },
      mock,
    })

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading Exposure by Geography...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Failed to load report: {error.message}
      </div>
    )
  }

  if (!report) {
    return (
      <div className="alert alert-warning" role="alert">
        Report not found
      </div>
    )
  }

  const geoData =
    report.section_content?.editor_data_content?.geographic_exposure_data

  return (
    <QuarterlyReportLayout
      title="Exposure by Geography"
      subtitle={`Exposure by Geography for ${report.household_name}`}
      showEditorActions={true}
      reportId={reportId}
      showPdfView={showPdfView}
      pdfLoading={pdfLoading}
      pdfUrl={pdfUrl}
      onTogglePdfView={togglePdfView}
      breadcrumbProps={{
        householdName: report.household_name,
        householdPath: `/manage/communications/${communicationId}/quarterly_reports/${reportId}`,
        sectionName: ReportSection.EXPOSURE_BY_GEOGRAPHY,
      }}
    >
      <PdfPageWrapper
        sectionTitle="Exposure by Geography"
        onPdfViewClick={loadPdfView}
      >
        <h3 className="pdf-page-section-title">Geographic Exposure</h3>
        {geoData && geoData.length > 0 ? (
          <GeographicExposureTable data={geoData} />
        ) : (
          <div className="editorjs-empty-tool-table">
            No table data available
          </div>
        )}
        <h3 className="pdf-page-section-title">Exposure by Geography</h3>
        {geoData && geoData.length > 0 ? (
          <USMap data={geoData} />
        ) : (
          <div className="editorjs-empty-tool-table">
            No geographic data available
          </div>
        )}
      </PdfPageWrapper>
    </QuarterlyReportLayout>
  )
}

export default ExposureByGeography
